// extracted by mini-css-extract-plugin
module.exports = {"BurgerMenu":"BurgerMenu_BurgerMenu__Fs7M8","BurgerMenu_opened":"BurgerMenu_BurgerMenu_opened__KIGq0","BurgerMenu__btn":"BurgerMenu_BurgerMenu__btn__NxcSt"};